import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from '../shared.module';
import { ValidationCodeComponent } from './validation-code.component';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
  declarations: [ValidationCodeComponent],
  imports: [
    SharedModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
  ],
  exports: [ValidationCodeComponent],
})
export class ValidationCodeModule {}
